import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {FormUtils} from '../../../../shared/utils/form.utils';
import {IonInput} from '@ionic/angular';
import {Focussable} from '../../focussable';

@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
})
export class NumberInputComponent implements AfterViewInit, OnChanges, Focussable {
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() required = false;
    @Input() pattern: RegExp = /^[+-]?(\d+(,\d{0,2})?|,\d{1,2})$/; // https://regexland.com/regex-decimal-numbers/
    @Input() invalidNumberLabel = 'Veuillez renseigner un nombre valide';
    @Input() unit: string;
    @Input() maxValue: number = undefined;
    @Input() minValue = 0;
    @Input() decimalDigits = 0;
    @Input() placeHolder: string;
    @Input() disabled = false;

    @Output() valueChangedEvent: EventEmitter<number> = new EventEmitter<number>();
    @Output() focussedEvent: EventEmitter<void> = new EventEmitter<void>();
    @ViewChild(IonInput) private _ionInput: IonInput;

    private validators: ValidatorFn[] = [];

    get numberFormControl() {
        return this.parentFormGroup.get(this.parentFormControlName) as UntypedFormControl;
    }

    ngAfterViewInit(): void {
        if(this.validators.length > 0) {
            this.addValidatorsOnFormControl(this.validators);
            this.validators = [];
        }
    }

    ngOnChanges(): void {
        let pattern;
        if (this.decimalDigits === 0) {
            pattern = /^[+-]?(\d+)$/;
        } else {
            /**
             * https://regexland.com/regex-decimal-numbers/
             * Voilà ce que donne la regexp avec un nombre de décimales à 2
             * /^[+-]?(\d+(,\d{0,2})?|,\d{1,2})$/;
             */
            pattern = new RegExp('^[+-]?(\\d+(\\.\\d{0,' + this.decimalDigits + '})?|\\.\\d{1,' + this.decimalDigits  + '})$');
        }
        this.addValidators(Validators.pattern(pattern));

        if (this.minValue !== null) {
            // console.logByType'add min validator = ', this.minValue);
            this.addValidators(Validators.min(this.minValue));
        }
        if (this.maxValue !== null) {
            this.addValidators(Validators.max(this.maxValue));
        }
        if (this.required) {
            this.addValidators(Validators.required);
        }
    }

    focus() {
        // console.log(['focus', this._ionInput]);
        this._ionInput?.setFocus();
    }

    private addValidators(validators: ValidatorFn) {
        if (this.numberFormControl) {
            this.addValidatorsOnFormControl(validators);
        } else {
            this.validators.push(validators);
        }
    }

    private addValidatorsOnFormControl(validators: ValidatorFn | ValidatorFn[]) {
        this.numberFormControl.addValidators(validators);
        this.numberFormControl.updateValueAndValidity();
    }

    collectErrors() {
        return FormUtils.collectErrors(this.numberFormControl);
    }

    changed(event: Event){
        const newValue = +(event.target as HTMLInputElement).value;
        this.valueChangedEvent.emit(newValue);
    }

    focussed(){
        this.focussedEvent.emit();
    }
}
